var React = require('react');

function IcAppsDesktopActive (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"y":"37","width":"48","height":"8","rx":"3","fill":"#FFE6D6","key":0}),React.createElement("rect",{"x":"2","y":"4","width":"44","height":"32","rx":"4","fill":"#FFE6D6","key":1}),React.createElement("rect",{"x":"5","y":"7","width":"38","height":"26","rx":"2","fill":"#FFC39C","key":2}),React.createElement("rect",{"x":"3","y":"36","width":"42","height":"5","rx":"2","fill":"#FFC39C","key":3})]);
}

IcAppsDesktopActive.defaultProps = {"id":"ic-apps-desktop-active","viewBox":"0 0 48 48","fill":"none"};

module.exports = IcAppsDesktopActive;

IcAppsDesktopActive.default = IcAppsDesktopActive;
